import { useQuery } from '@tanstack/react-query';

import { useListagemContext } from 'context/ListagemContext';
import { useRequestListagem } from 'hooks/useRequestListagem';
import { Totalizador } from 'pages/compra/pedido/types';

export function useQueryTotalizadorDataEntrega(dtEntrega?: string, hasMinimo?: boolean) {
    const requestListagem = useRequestListagem();
    const { getFilterValues } = useListagemContext();
    const { idLoja: lojas } = getFilterValues();
    const idLoja = lojas?.[0]?.idLoja;

    return useQuery<Totalizador>({
        queryKey: ['carrinho-totalizador-data-entrega', dtEntrega, idLoja],
        enabled: !!dtEntrega && !!idLoja && !!hasMinimo,
        queryFn: () =>
            requestListagem({
                url: '/compra/pedidovltotalwrapper/pedido',
                filter: [
                    {
                        property: 'idLoja',
                        operator: 'in',
                        value: [idLoja],
                    },
                    {
                        property: 'dtEntrega',
                        operator: 'eq',
                        value: dtEntrega,
                    },
                ],
                sort: [{ property: 'idPedido', direction: 'DESC' }],
            }).then((res) => res.data),
    });
}
